import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    const input = this.inputTarget;
    const defaultDate = input.value || null;

    this.instance = flatpickr(input, {
      defaultDate: defaultDate,
      mode: 'single',
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "d/m/Y",
      allowInput: true,
      locale: Portuguese,
    })
  }

  disconnect() {
    this.instance.destroy();
  }
}
